import { useMutation } from '@tanstack/react-query';
import { queryContext } from '@routable/shared';
import {} from '../models';
import { policyApi } from '../services';
export const useSaveApprovalPolicies = (id, version) => useMutation({
    mutationFn: async (values) => policyApi.save({ id, values, version }),
    context: queryContext,
});
